// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3X00l","actions":"GroupTable_actions__1vLqA","deleteModalFooter":"GroupTable_deleteModalFooter__mRJGf"};